import { Link } from 'react-router-dom';
import axios from 'axios';
import { useEffect, useState } from 'react';
import useApiUrl from '../framework/hooks/useApiUrlHook';

export default function WhatWeDo() {
    const apiUrl = useApiUrl();
    const [services, setServices] = useState([]);

    const getServices = () => {
        axios
            .get(`${apiUrl}/service/all`)
            .then((response) => {
                setServices(response.data);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    useEffect(() => {
        if (apiUrl != null) getServices();
    }, [apiUrl]);

    return (
        <div className="info-section sections section-b">
            <div className="info-layout">
                <div className="left" data-aos="fade-up" data-aos-delay={300} data-aos-duration={1000}>
                    <h2>Wat wij doen?</h2>
                    <h3>Verhogen van jouw (digitale) zichtbaarheid.</h3>
                    <p>
                        Vertrouw op onze vaardigheden en laat jouw bedrijf, zowel online als offline groeien door inzet
                        van de nieuwste technologieën.
                    </p>
                </div>
                <div className="right" data-aos="fade-up" data-aos-delay={400} data-aos-duration={1000}>
                    <ul className="list-wrap hover-effect">
                        {services?.map((service) => (
                            <li key={service.id}>
                                <a href={`/onze-diensten/${service.url}`}>
                                    <img src="/assets/img/icons/arrow-right.svg" alt="arrow" /> {service.titel}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
}
